<div
    class="input-container"
    [ngClass]="{ 'margin-small': marginBottom === 'small', 'margin-default': marginBottom === 'default' }"
>
    <div role="alert" [attr.aria-live]="'polite'">
        <label
            [ngClass]="{
                'label': true,
                'label-animation': !showError && control.value,
                'kk-visuallyhidden': showError || !control.value
            }"
            [for]="control | controlToKeyName"
        >{{ label }}</label
        >
        <label
            *ngIf="showError && (control.errors | firstKey | validationErrorMessage | translate)"
            class="label label-animation label-error"
            [for]="control | controlToKeyName"
        >{{ control.errors | firstKey | validationErrorMessage | translate }}</label
        >
    </div>
    <input
        class="input"
        [attr.id]="control | controlToKeyName"
        [ngClass]="{
            'input-valid': showValid,
            'input-error': showError,
            'input-label-padding':
                (showError && (control.errors | firstKey | validationErrorMessage | translate)) || control.value
        }"
        [formControl]="formControl"
        [name]="control | controlToKeyName"
        [placeholder]="placeholder"
        [attr.maxlength]="maxlength"
        [type]="type"
        [autocomplete]="autocomplete"
        [appAutoFocus]="autofocus"
        [attr.disabled]="disabled ? true : null"
        [attr.aria-label]="label"
        [attr.aria-invalid]="showError"
        (focus)="onFocus()"
        (blur)="onBlur()"
        #inputRef
    />
    <span *ngIf="showError && !clearButton" class="icon-error">
        <app-svg-icon iconName="error"></app-svg-icon>
    </span>
    <span *ngIf="showValid && !clearButton" class="icon-valid">
        <app-svg-icon iconName="tick"></app-svg-icon>
    </span>

    <button
        *ngIf="showClearButton"
        [attr.aria-label]="'forms.labels.clear' | translateSafe"
        (click)="onClearField()"
        class="btn-clear-icon"
    >
        <app-svg-icon iconName="close"></app-svg-icon>
    </button>
    <span *ngIf="helpText" class="input-help">{{ helpText }}</span>
</div>
